'use client';

import { cn } from '@repo/utils/cn';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import CryptoCard from '@/app/[locale]/(landing)/components/crypto-cards/card';
import { CRYPTO_CARDS } from '@/app/[locale]/(landing)/components/crypto-cards/card-options';
import { useTenant } from '@/providers/TenantProvider';

const CryptoCards = () => {
  const t = useTranslations('landing.crypto-cards');

  const {
    tenantConfig: { settings },
  } = useTenant();
  const cards = CRYPTO_CARDS.filter((card) => !(!settings.enableVatanCoinPromotion && card.id === 'VATAN'));

  const [selectedCard, setSelectedCard] = useState(cards[0]);

  return (
    <section className="flex w-full flex-col space-y-5 rounded-md border p-3 vt-tab-item-secondary-stroke sm:flex-row sm:space-y-0 sm:p-0">
      <div className="flex w-full flex-col justify-center p-2 sm:w-1/2 sm:px-14">
        <h2 className="leading-tight vt-font-highlight-font-family">
          <span className="text-4xl font-black vt-colors-accents-accent-2-600">{t('title')}</span>
          <br />
          <span className="text-4xl font-black vt-headings-text">{t('sub-title')}</span>
        </h2>
        <p className="mt-4 vt-body-text-default">{t('description')}</p>
      </div>

      <div className="flex w-full items-center justify-center sm:w-1/2">
        <div className="via-50 flex min-h-0 w-full flex-1 flex-col items-center gap-2 overflow-hidden rounded-lg bg-gradient-to-tr from-[var(--containers-settings-box-light-bg)] via-[var(--body-bg)] to-[var(--body-bg)] p-3 sm:flex-row sm:bg-gradient-to-bl">
          <div className="flex w-full items-center justify-between gap-3 sm:w-auto sm:flex-col sm:items-start sm:justify-start">
            {cards.map(({ id, Icon }, idx) => (
              <div
                key={id}
                onClick={() => setSelectedCard(cards[idx])}
                className={cn('inline-flex cursor-pointer items-center justify-center rounded-full p-[1px]', {
                  'vt-atoms-btn-primary-bg': selectedCard.id === id,
                })}
              >
                <div
                  className={cn('flex h-8 w-8 items-center justify-center overflow-hidden rounded-full p-0.5', {
                    'vt-body-bg': selectedCard.id === id,
                  })}
                >
                  <Icon />
                </div>
              </div>
            ))}
          </div>

          <div className="relative flex w-full justify-center sm:flex-1">
            <div className="mx-auto sm:max-w-md">
              <CryptoCard
                // key={selectedCard.id}
                src={selectedCard.src}
                alt="alt"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CryptoCards;
